/**
 * Tiny stale-while-revalidate cache (perf): sessionStorage-backed, so returning
 * to a list/card paints INSTANTLY from the last-seen copy while a fresh fetch
 * runs behind and replaces it. Session-scoped (cleared on tab close), size-capped.
 */
const PREFIX = 'guest-swr:';
const MAX_ENTRIES = 60;

export function cacheGet<T>(key: string): T | null {
  try {
    const raw = sessionStorage.getItem(PREFIX + key);
    return raw ? (JSON.parse(raw) as T) : null;
  } catch {
    return null;
  }
}

export function cacheSet(key: string, value: unknown): void {
  try {
    sessionStorage.setItem(PREFIX + key, JSON.stringify(value));
    // Cheap size cap: drop oldest-inserted keys once over budget.
    const keys: string[] = [];
    for (let i = 0; i < sessionStorage.length; i++) {
      const k = sessionStorage.key(i);
      if (k?.startsWith(PREFIX)) keys.push(k);
    }
    while (keys.length > MAX_ENTRIES) sessionStorage.removeItem(keys.shift()!);
  } catch {
    /* quota/private mode — cache is best-effort */
  }
}
